import api from './api'

export const pushNotificationsService = {
  // Récupérer toutes les notifications
  getAll: (page = 1, limit = 20, status = null) => {
    const params = new URLSearchParams({ page, limit })
    if (status) {
      params.append('status', status)
    }
    return api.get(`/api/admin/push-notifications?${params.toString()}`)
  },

  // Récupérer une notification par ID
  getById: (id) => {
    return api.get(`/api/admin/push-notifications/${id}`)
  },

  // Obtenir les statistiques
  getStats: () => {
    return api.get('/api/admin/push-notifications/stats')
  },

  // Créer une nouvelle notification
  create: (notificationData) => {
    return api.post('/api/admin/push-notifications', notificationData)
  },

  // Mettre à jour une notification
  update: (id, notificationData) => {
    return api.put(`/api/admin/push-notifications/${id}`, notificationData)
  },

  // Supprimer une notification
  delete: (id) => {
    return api.delete(`/api/admin/push-notifications/${id}`)
  },

  // Envoyer une notification immédiatement
  sendNow: (id) => {
    return api.post(`/api/admin/push-notifications/${id}/send-now`)
  },
}










